import './Arrows.less';

import Icon from '@plone/volto/components/theme/Icon/Icon';
import cx from 'classnames';
import { defineMessages, useIntl } from 'react-intl';

import leftArrowSVG from '@plone/volto/icons/left-key.svg';
import rightArrowSVG from '@plone/volto/icons/right-key.svg';

const messages = defineMessages({
  next: {
    id: 'Next',
    defaultMessage: 'Next',
  },
  previous: {
    id: 'Previous',
    defaultMessage: 'Previous',
  },
});

const Arrow = (props) => {
  const { className, onClick, label, icon, outside } = props;

  const intl = useIntl();

  return (
    <button
      className={cx(
        'br-button primary circle small',
        { outside },

        className,
      )}
      onClick={onClick}
      aria-label={intl.formatMessage(label)}
    >
      <Icon name={icon} />
    </button>
  );
};

const NextArrow = (props) => (
  <Arrow label={messages.next} icon={rightArrowSVG} {...props} />
);
const PrevArrow = (props) => (
  <Arrow label={messages.previous} icon={leftArrowSVG} {...props} />
);

export { NextArrow, PrevArrow };
